import React, { useEffect, useContext } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FourOhFourError, StaticContext } from '@sm/webassets';
import { MetricsTracker } from '@sm/metrics';

import {
  HomePage,
  CategoriesPage,
  FeaturedPage,
  MostPopularPage,
  RecentlyAddedPage,
  SearchPage,
  MyAppsPage,
  DetailsPage,
  HomePageV2,
  DetailsV2Page,
} from './pages';

const AppsDirectoryRouter = ({ history }) => {
  const {
    user,
    environment: { countryCode: country },
    'client-config': { loggingAPIPath, amplitudeToken },
  } = useContext(StaticContext);

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    MetricsTracker.initialize({
      user: { id: user.id, isAuthenticated: user.isAuthenticated },
      loggingAPIPath,
      country,
      pageId: 'AppDirectory',
      amplitudeToken,
    });
  }, [user, country, loggingAPIPath, amplitudeToken]);

  // Hide usabilla for all pages - each individual page will set usabilla configs and show if enabled
  // Note the load of usabilla hides the button so this code is included if usabilla has already been loaded
  if (typeof window !== 'undefined' && window && window.usabilla_live) {
    window.usabilla_live('virtualPageView');
    window.usabilla_live('hide');
  }

  return (
    <Switch>
      <Route path="/apps/:appId/preview" render={props => <DetailsPage {...props} preview />} />
      <Route path="/apps/:appId/details" component={DetailsPage} exact />
      <Route path="/apps/my-apps" component={MyAppsPage} exact />
      <Route path="/apps/recently-added" component={RecentlyAddedPage} exact />
      <Route path="/apps/most-popular" component={MostPopularPage} exact />
      <Route path="/apps/featured-apps" component={FeaturedPage} exact />
      <Route path="/apps/search" component={SearchPage} exact />
      <Route path="/apps/categories/:categoryKey" component={CategoriesPage} exact />

      <Route path="/apps/v2/:appId/details" component={DetailsV2Page} exact />
      <Route path="/apps/v2" component={HomePageV2} exact />

      <Route path="/apps" component={HomePage} exact />

      <Route component={FourOhFourError} />
    </Switch>
  );
};

AppsDirectoryRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(AppsDirectoryRouter);
